import { isValidEnv } from './featureFlagEnv';
import valueMap from './flagValueMapper';
// Flags for enabling/disabling a feature
const Featureflag = {
  //       local: v1,stag: v2,vops: v3,
  cargoRename: isValidEnv(valueMap(true, true, true)),
  noLogger: isValidEnv(valueMap(false, false, false)),
  autogr: isValidEnv(valueMap(true, true, true)),
  mls: isValidEnv(valueMap(true, true, true)),
};
export default Featureflag;



// WEBPACK FOOTER //
// ./src/utils/featureFlag.js